import React from 'react';
import { useSelection } from '../context/SelectionContext';

const Toast = () => {
  const { notice } = useSelection();
  if (!notice) return null;
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[60] px-4 pointer-events-none">
      {/* W ciemnym motywie `gray-900` zlewa się z tłem strony (oba prawie czarne),
          więc komunikat wychodzi o dwa stopnie w górę skali — musi ODCINAĆ SIĘ od
          podłoża, bo znika po kilku sekundach i nie ma drugiej szansy. */}
      <div className="bg-gray-900 dark:bg-gray-700 text-white text-sm px-4 py-2.5 rounded-lg shadow-lg max-w-sm text-center">
        {notice.msg}
      </div>
    </div>
  );
};

export default Toast;
